import { useMemo } from 'react';
import { useRecordCardProperties, useGetProperty } from 'crm-object-board-core/properties';
export const useCardProperties = () => {
  const cardPropertyNames = useRecordCardProperties();
  const getProperty = useGetProperty();
  return useMemo(() => {
    return cardPropertyNames ? cardPropertyNames.map(propertyName => getProperty(propertyName)).filter(item => !!item) : [];
  }, [cardPropertyNames, getProperty]);
};